import { useToken } from '@ori/auth';
import { useServiceUrls } from '@ori/configuration-manager';
import { useEnvironment } from '@ori/environment';
import { useSWR } from '@ori/fetching';
import { useLanguage } from '@ori/i18n';
import { getRetryErrorSwrOptions } from '@ori/presentation-utils';
import { getTopAreaData, TopArea } from '@ori/top-area';
import { useMemo } from 'react';
import { BurgerPersonalMenuOutlet } from './BurgerPersonalMenuOutlet';
import { jsx as _jsx } from "react/jsx-runtime";
export const App = ({
  clientAppConfig
}) => {
  const {
    isUserVerified
  } = useToken();
  const {
    staticApiUrl
  } = useServiceUrls(['staticApi']);
  const {
    tenant
  } = useEnvironment();
  const {
    language
  } = useLanguage();
  const {
    data,
    isLoading
  } = useSWR(isUserVerified ? 'top-area-navigation' : null, async () => getTopAreaData({
    language,
    staticApiUrl,
    tenant
  }), getRetryErrorSwrOptions());
  const configuration = useMemo(() => ({
    ...clientAppConfig,
    ...data
  }), [clientAppConfig, data]);
  if (isLoading) {
    return null;
  }
  return /*#__PURE__*/_jsx(TopArea, {
    configuration: configuration,
    mobilePersonalMenuOutlet: /*#__PURE__*/_jsx(BurgerPersonalMenuOutlet, {})
  });
};